module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ext_split"
  }, [_c('i', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  })]), _c('b', [_vm._v("TO THE CITIZENS OF SEMPERA")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('i', [_vm._v("A NOTICE for the capture of Jules Ember of Crofton, murderer of the First Queen, the late Savior of Sempera, the Lady of Centuries; and of Lord Roan Gerling, beloved son of Lord Nicholas Gerling and Lady Verissa Gerling, devoted brother of Lord Liam Gerling.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('i', [_vm._v("A reward of five hundred years of blood-iron is offered for the murderess’s living capture and delivery to Queen Ina Gold’s soldiers.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42212847","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062653710_Frontmatter.vue
// module id = 72
// module chunks = 0